"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/PatientDrawer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _PatientPage = require('web/screens/Directory/PatientPage'); var _PatientPage2 = _interopRequireDefault(_PatientPage);
var _AccessHistory = require('web/screens/Directory/PatientPage/AccessHistory'); var _AccessHistory2 = _interopRequireDefault(_AccessHistory);
var _Tooltip = require('web/components/Tooltip');


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _format = require('./format');

















// Clicks here keep the panel open: the panel itself and the dialogs and
// menus it opens. A screen adds its own rows, which open, switch or close it.
 const DRAWER_KEEPS_OPEN = '.dir-drawer, .blm-modal, .ReactModalPortal, [role="dialog"], [role="menu"], [role="listbox"]'; exports.DRAWER_KEEPS_OPEN = DRAWER_KEEPS_OPEN

/* One patient over the table: today's patient page in a 440px panel on the
 * right, with no backdrop, so the table doesn't move (D-18, patients-v3-detail).
 * It adds Message Activity, Tags, Add to broadcast and, for admins, Archive
 * patient in the header's More menu (patients-v3-member-detail has no
 * Archive). Escape closes it. */
const PatientDrawer = ({
  orgKey, patientKey, row, isAdmin, pendingKind, onClose, onAction, onRemoveTag, onRequestPatientsFeature, onStartChat,
}) => {
  _react.useEffect.call(void 0, () => {
    // Escape closes what's on top first: a dialog, or the header's More menu.
    const onKey = (e) => {
      if (e.key === 'Escape' && !document.querySelector('.blm-modal, .right-side-header--more-toggle--active')) onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const isArchived = !!_optionalChain([row, 'optionalAccess', _ => _.Archived])
  const panel = _react.useMemo.call(void 0, () => ({
    onClose,
    created: _format.formatDay.call(void 0, _optionalChain([row, 'optionalAccess', _2 => _2.CreatedAt])),
    sections: (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, "Message Activity" )
        , _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
          , _react2.default.createElement('div', { className: "directory-page--info-section--metadata", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
            , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
              , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "Last from patient"  )
              , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}},  _format.formatActivity.call(void 0, _optionalChain([row, 'optionalAccess', _3 => _3.LastFromPatientAt])) )
            )
            , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
              , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "Last to patient"  )
              , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  _format.formatActivity.call(void 0, _optionalChain([row, 'optionalAccess', _4 => _4.LastToPatientAt])) )
            )
          )
        )
        , _react2.default.createElement(_AccessHistory2.default, { orgKey: orgKey, patientKey: patientKey, patientName: _nullishCoalesce(_optionalChain([row, 'optionalAccess', _5 => _5.Name]), () => ( '')), __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}} )
        , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Tags")
        , _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
          ,  !!_optionalChain([row, 'optionalAccess', _6 => _6.Tags, 'access', _7 => _7.length]) && (
            _react2.default.createElement('div', { className: "dir-tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
              ,  row.Tags.map(tag => (
                _react2.default.createElement('span', { key: tag.TagKey, className: "blm-name--badge dir-tag--removable" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
                  ,  tag.Name 
                  , _react2.default.createElement('button', { type: "button", className: "dir-tag--remove", 'aria-label': `Remove tag ${tag.Name}`, onClick: () => onRemoveTag(tag), __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "×")
                )
              ))
            )
          )
          /* Add tag waits for the row, so it tags in the patient's own view (review F-10). */
          , _react2.default.createElement('div', {
            role: "button",
            tabIndex: row ? 0 : -1,
            'aria-disabled': !row || undefined,
            className: _classBuilder2.default.call(void 0, 'directory-page--add-btn', !row && 'dir-add-btn--waiting'),
            onClick: () => { if (row) onAction({ kind: 'tag', patientKeys: [patientKey], isArchived }) },
            onKeyDown: e => { if (row && (e.key === 'Enter' || e.key === ' ')) onAction({ kind: 'tag', patientKeys: [patientKey], isArchived }) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}

            , _react2.default.createElement('div', { className: "directory-page--add-btn--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), "Add tag"
          )
        )
      )
    ),
    footer: row && !isArchived && (
      _react2.default.createElement('div', { className: "dir-drawer--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: () => onAction({ kind: 'broadcast', patientKeys: [patientKey] }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
          , _react2.default.createElement('img', { alt: "", src: "/assets/icons/broadcast/broadcast-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}} ), "Add to campaign"
        )
      )
    ),
    // Archive or Restore waits for the row, so it never offers the wrong one.
    menuItem: isAdmin && row && (
      _react2.default.createElement(_Tooltip.TooltipMenuItem, {
        iconSrc: "/assets/icons/icon-completed-dark-grey.svg",
        label: isArchived ? 'Restore patient' : 'Archive patient',
        desc: pendingKind ? (pendingKind === 'archive' ? 'Being archived' : 'Being restored') : undefined,
        disabled: !!pendingKind,
        onClick: () => onAction(isArchived ? { kind: 'restore', patientKeys: [patientKey] } : { kind: 'archive', patientKeys: [patientKey] }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
      )
    ),
  }), [onClose, row, isArchived, isAdmin, pendingKind, onAction, onRemoveTag, orgKey, patientKey])

  return (
    _react2.default.createElement('aside', { className: "dir-drawer", role: "dialog", 'aria-label': "Patient details" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
      , _react2.default.createElement(_PatientPage2.default, {
        orgKey: orgKey,
        patientKey: patientKey,
        onRequestPatientsFeature: onRequestPatientsFeature,
        onStartChat: onStartChat,
        panel: panel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
      )
    )
  )
}

exports. default = PatientDrawer
